// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","botLink":"Footer_botLink__04t6B","srcLink":"Footer_srcLink__R4KNZ"};